import { Language } from '../context/LanguageContext';

interface ContactModalTranslations {
    title: string;
    visitStore: {
        title: string;
        description: string;
        buttonText: string;
    };
    callUs: {
        title: string;
        description: string;
    };
    email?: {
        title: string;
        description: string;
    };
}

const contactModalTranslations: Record<Language, ContactModalTranslations> = {
    en: {
        title: "Contact Us",
        visitStore: {
            title: "Visit a Store",
            description: "Experience our collection in person at our nearest boutique",
            buttonText: "Find Nearest Store"
        },
        callUs: {
            title: "Call Us",
            description: "Speak with our customer service representative"
        },
        email: {
            title: "Email Us",
            description: "Send us your inquiry"
        }
    },
    de: {
        title: "Kontaktieren Sie uns",
        visitStore: {
            title: "Besuchen Sie eine Boutique",
            description: "Erleben Sie unsere Kollektion persönlich in unserer nächstgelegenen Boutique",
            buttonText: "Nächste Boutique Finden"
        },
        callUs: {
            title: "Rufen Sie Uns An",
            description: "Sprechen Sie mit unserem Kundenservice"
        },
        email: {
            title: "E-Mail",
            description: "Senden Sie uns Ihre Anfrage"
        }
    },
    fr: {
        title: "Contactez-nous",
        visitStore: {
            title: "Visitez une Boutique",
            description: "Découvrez notre collection en personne dans notre boutique la plus proche",
            buttonText: "Trouver la Boutique la Plus Proche"
        },
        callUs: {
            title: "Appelez-nous",
            description: "Parlez avec notre représentant du service client"
        },
        email: {
            title: "Envoyez-nous un Email",
            description: "Envoyez-nous votre demande"
        }
    },
    zh: {
        title: "聯繫我們",
        visitStore: {
            title: "參觀門店",
            description: "親臨我們最近的精品店，親身體驗我們的系列",
            buttonText: "尋找最近的門店"
        },
        callUs: {
            title: "聯繫我們",
            description: "與我們的客戶服務代表交談"
        },
        email: {
            title: "電子郵件",
            description: "發送您的查詢"
        }
    }
};

export function getContactModalTranslations(language: Language): ContactModalTranslations {
    return contactModalTranslations[language] || contactModalTranslations.en;
}

export type { ContactModalTranslations }; 